import styled from "styled-components";

export const Section = styled.section`
  padding: 72px clamp(16px, 5vw, 72px);
  background: ${({ $insurance }) => ($insurance ? "#173f1e" : "#f6f2e9")};
  color: ${({ $insurance }) => ($insurance ? "#fff" : "inherit")};
  @media (max-width: 767px) { padding-top: 36px; padding-bottom: 36px; }
`;
export const Inner = styled.div`max-width:1180px;margin:0 auto;`;
export const Eyebrow = styled.p`
  margin: 0 0 9px;
  color: ${({ theme }) => theme.color.orange};
  font-size: 13px;
  font-weight: 900;
  letter-spacing: .09em;
  text-transform: uppercase;
`;
export const Split = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(320px, .9fr);
  gap: clamp(24px, 5vw, 64px);
  align-items: center;
  @media (max-width: 760px) { grid-template-columns: 1fr; gap: 24px; }
`;
export const Copy = styled.div`
  h2 { max-width: 720px; margin: 0 0 16px; font-size: clamp(32px, 5vw, 50px); line-height: 1.06; }
  p { max-width: 720px; margin: 0; color: inherit; opacity: .82; font-size: 17px; line-height: 1.62; }
  @media (max-width: 767px) { h2 { font-size: 28px; } p { font-size: 16px; line-height: 1.5; } }
`;
export const Details = styled.div`
  padding: 24px;
  border: 1px solid rgba(255,255,255,.2);
  border-radius: 22px;
  background: rgba(255,255,255,.08);
  strong { font-size: 20px; }
  summary { cursor: pointer; font-size: 17px; font-weight: 800; min-height: 24px; }
  ul { display: grid; gap: 8px; margin: 15px 0; padding-left: 20px; }
  small { display: block; color: rgba(255,255,255,.76); line-height: 1.55; }
`;
export const FirmIcons = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0,1fr));
  gap: 10px;
  >div, >a { display:grid; justify-items:center; align-content:center; min-height:104px; gap:6px; padding:12px 8px; border:1px solid #e1e6df; border-radius:17px; background:#fff; color:#26352a; text-align:center; text-decoration:none; }
  >a:hover { border-color:#ffa900; background:#fff9ed; }
  >a:focus-visible { outline:3px solid #ffa900; outline-offset:3px; }
  strong { font-size:13px; line-height:1.3; }
  img { width:42px; height:42px; object-fit:contain; }
  small { color:#26352a; font-size:12px; line-height:1.3; font-weight:800; }
  @media (max-width: 430px) { grid-template-columns: repeat(2,minmax(0,1fr)); >div:last-child, >a:last-child { grid-column: 1 / -1; } }
`;
export const Actions = styled.div`
  display:flex;
  flex-wrap:wrap;
  gap:9px;
  margin-top:24px;
  a { display:inline-flex; align-items:center; justify-content:center; min-height:50px; padding:0 19px; border-radius:999px; background:${({theme})=>theme.color.orange}; color:${({theme})=>theme.color.black}; font-size:13px; font-weight:900; text-align:center; text-decoration:none; }
  a+a { background:${({$firm})=>$firm?"#e8efe6":"rgba(255,255,255,.12)"}; color:${({$firm,theme})=>$firm?theme.color.green:"#fff"}; }
  @media (max-width:620px) { display:grid; a { width:100%; } }
`;
